"use strict";

exports.__esModule = true;
exports.FlexSpacer = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * A utility component used to create spacing in FlexRows and FlexColumns;
 */

var FlexSpacer = exports.FlexSpacer = function FlexSpacer() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, null);
};